/**
 * Batch joins and react-select often pass courseId as a string, { id, name }, or [{ id }].
 * Use before URL/query params so we never send "[object Object]".
 * Recurses when id/_id values are nested objects (e.g. some ORM shapes).
 */
export function resolveCourseId(raw, depth = 0) {
  if (depth > 8) return "";
  if (raw == null || raw === "") return "";
  if (typeof raw === "string") {
    const s = raw.trim();
    return s;
  }
  if (typeof raw === "number" || typeof raw === "boolean") {
    return String(raw).trim();
  }
  if (typeof raw !== "object") {
    return String(raw).trim();
  }

  if (Array.isArray(raw)) {
    if (raw.length === 0) return "";
    return resolveCourseId(raw[0], depth + 1);
  }

  const id = raw.id ?? raw._id;
  if (id != null && typeof id === "object") {
    return resolveCourseId(id, depth + 1);
  }
  if (id != null) {
    return String(id).trim();
  }

  if (raw.courseId != null) {
    const nested = resolveCourseId(raw.courseId, depth + 1);
    if (nested) return nested;
  }

  return "";
}
